import { Button } from '@mantine/core';

import BaseModal from '@/components/BaseModal.tsx';

interface Props {
    visible: boolean;
    setVisible: (isVisible: boolean) => void;
    onConfirm: () => void;
    onCancel: () => void;
}

export const RescheduleNotificationModal = ({ visible, setVisible, onConfirm, onCancel }: Props) => {
    const handleClose = (): void => {
        setVisible(false);
    };

    const handleConfirm = (): void => {
        onConfirm();
        setVisible(false);
    };

    const handleCancel = (): void => {
        onCancel();
        setVisible(false);
    };

    const footer = [
        <Button key="cancel" variant="outline" onClick={handleCancel}>
            Nein, trotzdem buchen
        </Button>,
        <Button key="confirm" onClick={handleConfirm}>
            Ja, benachrichtigen
        </Button>,
    ];

    return (
        <BaseModal
            opened={visible}
            onClose={handleClose}
            size="md"
            title="Patient:in benachrichtigen?"
            footer={footer}
            zIndex={420}
        >
            <div className="flex flex-col gap-4">Möchten Sie die Patient:in über diese Änderung informieren?</div>
        </BaseModal>
    );
};
